<template>
  <el-table
    :data="data"
    @selection-change="handleSelectionChange"
    :empty-text="emptyText"
    stripe
    style="width: 100%;">
    <el-table-column
      v-if="selection"
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      label="Produit"
      width="200">
      <template slot-scope="props">
        <span v-if="props.row.reconcileItem.product">
          <el-link
            type="primary"
            @click="openProductDrawer(props.row.reconcileItem.product)">
            {{props.row.reconcileItem.product.sku}}
        </el-link>
        </span>
        <i v-else class="mdi mdi-alert " style="color:#EC205F;font-size:20px;"></i>
      </template>
    </el-table-column>

    
    <el-table-column
      prop=""
      label="Nb lot"
      width="90">
      <template slot-scope="props">
        <span style="word-break:break-word;">{{getNblot(props.row)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      v-if="error === false"
      label="description">
      <template slot-scope="props">
        <span style="word-break:break-word;">{{props.row.reconcileItem.product.name}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      v-if="error === true"
      label="description">
      <template slot-scope="props">
        <span style="word-break:break-word;">{{props.row.reconcileItem.description}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      label="Prix Part."
      align="center"
  >
      <template slot-scope="props">
        <span style="word-break:break-word;" v-if="props.row.reconcileItem.newRetailPrice">{{formatAmount(getLastItemPriceTaxIn(props.row.reconcileItem.items))}} -> <span>{{formatAmount(props.row.reconcileItem.newRetailPrice)}}</span> </span>
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      label="Prix Titulare"
      align="center"
    >
      <template slot-scope="props">
        <span style="word-break:break-word;" v-if="props.row.reconcileItem.newLicenseePrice">{{formatAmount(getLastItemPrice(props.row.reconcileItem.items))}} -> <span>{{formatAmount(props.row.reconcileItem.newLicenseePrice)}}</span></span>
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      label="Date d'entrée en vigueur"
      align="center"
    >
      <template slot-scope="props">
        <span>{{ props.row.reconcileItem.effectiveDate }}</span>
        <span class="mdi mdi-alert-outline m-20 danger-text" v-if="dateIsInFuture(props.row.reconcileItem.effectiveDate)"></span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      label="Prix référence"

width="180"
      v-if="error === false"
    >
      <template slot-scope="props">
        <span v-if="hasReferencePrice(props.row.reconcileItem.product)">
          <el-input  v-model="props.row.reconcileItem.product.sellingUnitPrice"></el-input>
          <span v-if="hasPriceByClasses(props.row.reconcileItem.product)" class="pl-5">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content" style="text-align: center;">Attention! Il y a une configuration de prix par classe client sur ce produit. </br>Si vous voulez changer ces prix, veuillez le faire dans la section configuration des produits.</div>
              <span class="mdi mdi-alert"></span>
            </el-tooltip>
          </span>
        </span>
        
        <span v-else>--</span>
      </template>
    </el-table-column>
     <el-table-column
      prop=""
      label="Frais fixe"

      width="180"
      v-if="error === false"
    >
      <template slot-scope="props">
        <span v-if="hasFixedAgencyFees(props.row.reconcileItem.product)">
          <el-input  style="width:100px" v-model="props.row.reconcileItem.product.agencyFee"></el-input>
           <span v-if="hasPriceByClasses(props.row.reconcileItem.product)" class="pl-5">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content" style="text-align: center;">Attention! Il y a une configuration de prix par classe client sur ce produit. </br>Si vous voulez changer ces prix, veuillez le faire dans la section configuration des produits.</div>
              <span class="mdi mdi-alert"></span>
            </el-tooltip>
          </span>
        </span>
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column
      prop=""
      label="Frais (%)"
      width="180"

      v-if="error === false"
    >
      <template slot-scope="props">
        <span v-if="!hasReferencePrice(props.row.reconcileItem.product) && !hasFixedAgencyFees(props.row.reconcileItem.product)">
          {{ getMarge(props.row.reconcileItem) }}
        </span>
        <span v-else>--</span>
      </template>
    </el-table-column>
   
    
  </el-table>
</template>
<script>

import portausUtils from '@/utils/portaus-utils';
import dayjs from 'dayjs';


export default {
  name: 'Reconciliation-Price-table',
	props: {
    data : {
      type : Array,
      require : true
    },
    error : {
      type : Boolean,
      default : false,
    },
    selection : {
      type : Boolean,
      defaultValue : false,
    },
    emptyText : {
      type: String,
      defaultValue: 'Aucune données'
    }
	},
  data() {
    return {
      multipleSelection : [],
    };
  },components: {

  },
	methods: {
    dateIsInFuture (date) {
      return dayjs(date).isAfter(dayjs());
    },
      getLastItemPrice(items) {
        const lastItem = this.getLastItem(items);
        return lastItem ? lastItem.price : null;
      },
      getLastItemPriceTaxIn(items) {
        const lastItem = this.getLastItem(items);
        return lastItem ? lastItem.priceTaxIn : null;
      },
      getLastItem(items) {
        const sortedItems = _.sortBy(items, item => item.availabilityDate);
        return _.last(sortedItems);
      },
      formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
      getMarge(reconcileItem) {
        if (_.get(reconcileItem, 'product.agencyRate') !== null){
          return (_.get(reconcileItem, 'product.agencyRate') * 100).toFixed(2) + '%';
        }

        const diff = _.get(reconcileItem, 'product.sellingUnitPrice', 0) - _.get(reconcileItem, 'newLicenseePrice', 0);
        if (diff <= 0) {
          return  0;
        } else {
          return (diff / _.get(reconcileItem, 'newLicenseePrice') * 100).toFixed(2) + '%';
        }

      },
      hasPriceByClasses (product) {
        if (product == null) {
          return false;
        }
        return _.get(product, 'pricing.pricesByClasses') != null && _.size(_.get(product, 'pricing.pricesByClasses')) > 0;
      },
      hasFixedAgencyFees (product) {
         if (product == null) {
          return false;
        }
        return _.get(product, 'agencyFee') !== null;
      },
      hasReferencePrice(product) {
        if (product == null) {
          return false;
        }
        return _.get(product, 'agencyRate') == null && _.get(product, 'agencyFee') == null;
      },
      getNblot(row) {
        return _.size(_.get(row, 'reconcileItem.items', []));
      },
      openProductDrawer(product){
        console.log("open product drawer", product);
        this.$emit('openProduct', product.puid);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.$emit('selectionChanged', val);
      }
	},
	computed: {
    
	}
}
</script>
<style lang="scss" >




</style>
